import { Container } from '@mui/material';
import React from 'react';

const Blogs = () => {
    return (
      <Container>
          <h1>Blogs Comming Soon</h1>
      </Container>
    );
};

export default Blogs;